import React, { useCallback } from 'react';

import useSetPaymentMethods from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/hooks/useSetPaymentMethods';
import Immediately from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/Immediately';
import { DefaultPaymentMethodBlockProps } from '@/modules/transaction/components/ReimburseMe/ConfirmationStep/Immediately/ImmediatelyButton';
import { PaymentMethodType } from '@/modules/user/user.types';

import DefaultPaymentMethodBlock from './DefaultPaymentMethodBlock';
import FixYourAddressWarningCardWrapper from './FixYourAddressWarningCardWrapper';

const DefaultPaymentMethodContainer: React.FC = () => {
  const { organizationProperties, handleGettingPaymentMethods } = useSetPaymentMethods();

  const immediatelyButtonRenderWrapper = useCallback(({
    activeMethod,
    isLoading,
    isVerificationFailed,
    isVerificationPending,
    onAddOrChangeClick,
    paymentEmployeeFee,
  }: DefaultPaymentMethodBlockProps) => {
    return (
      <DefaultPaymentMethodBlock
        isLoading={isLoading}
        activeMethod={activeMethod}
        paymentEmployeeFee={paymentEmployeeFee}
        isVerificationFailed={isVerificationFailed}
        isVerificationPending={isVerificationPending}
        onAddOrChangeClick={onAddOrChangeClick}
      />
    );
  }, []);

  const cardFooterRenderWrapper = useCallback(( paymentMethodType?: PaymentMethodType) => {
    return <FixYourAddressWarningCardWrapper paymentMethodType={paymentMethodType} />;
  }, []);

  return (
    <Immediately
      type="full"
      allowedPaymentMethodConfigs={organizationProperties?.allowedPaymentMethodConfigs}
      onGetPaymentMethods={handleGettingPaymentMethods}
      renderWrapper={immediatelyButtonRenderWrapper}
      cardFooterRenderWrapper={cardFooterRenderWrapper}
    />
  );
};

export default DefaultPaymentMethodContainer;